import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ShellDomainProvider } from '../../../standalone-packages/ecap3/core';
import { ClaimOrderModel } from '../../../models/responseModels/ClaimOrderModel';
import { Router } from '@angular/router';

@Component({
    selector: 'app-connected-repair-cases',
    templateUrl: './connected-repair-cases.component.html',
    styleUrls: ['./connected-repair-cases.component.scss'],
    standalone: false
})
export class AppConnectedRepairCasesComponent {
    @Input() duplicateClaimCaseList: ClaimOrderModel[] = [];
    ClaimCenterUrl = `${ShellDomainProvider['api'].ClaimCenterLinkBaseUri}`;

    constructor(private readonly router: Router,
        public readonly translateService: TranslateService
    ) {}

    getRepairCenterClaimUrl(claimOrder: ClaimOrderModel): string {      
        if (!claimOrder?.orderId) {
            return '';
        }
        return this.ClaimCenterUrl + '/claim/details/' + claimOrder.orderId;
    }
}
